import http from "@/http/http.js";
let baseURL = "";
if (process.env.NODE_ENV == 'development') {//开发环境
    baseURL = '/api/web/action/opNeed/springBoard';
} else if (process.env.NODE_ENV == 'production') {//生产环境
    baseURL = '/web/action/opNeed/springBoard';
}
// 免费咨询 (需求单)
export function opSubmitNeed(params) {
    return http.post(baseURL, {
        actionType: "opSubmitNeed",
        actionBody: params
    });
}
// 需求列表
export function opNeedList(params) {
    return http.post(baseURL, {
        actionType: "opNeedList",
        actionBody: params
    });
}
// 需求详情
export function getItemByNeedNo(params) {
    return http.post(baseURL, {
        actionType: "getItemByNeedNo",
        actionBody: params
    });
}